'use strict'

class TemplateOverviewCtrl {

    constructor ($http, $timeout, $state, $mdDialog, $mdToast, Template) {

        // Dependencies
        this.$http = $http
        this.$timeout = $timeout
        this.$state = $state
        this.$mdDialog = $mdDialog
        this.$mdToast = $mdToast
        this._Template = Template

        // Controller vars
        this.contentLoaded = false
        this.collection = []

        // Paginator
        this.pagination = {
            current: 1
        }

        // Fetch the overview items
        this.fetch(1)
    }

    fetch (pageNumber) {
        this.$http.get('/templateblocks_overview/?page=' + pageNumber)
            .then((response) => {
                this.templates = response.data.data
                this.totalResults = response.data.total
                this.resultPerPage = response.data.per_page
                this.contentLoaded = true
            })
        this.pageChanged = function (newPage) {
            getResultsPage(newPage)
        }
    }

    destroy (id, title, index, event) {
        event.stopPropagation()

        this.$mdDialog.show({
            controller: 'ConfirmDialogCtrl',
            templateUrl: 'confirmDialog.ngTemplate',
            parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: event,
            clickOutsideToClose: true,
        })
            .then(() => {
                this.collection.splice(index, 1)

                this._Template.delete({ id: id }, () => {
                    this.fetch(this.pagination.current)
                })

                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.delete?object=template&title=' + title,
                    hideDelay: 3000,
                    position: ('top right'),
                })

                this.$state.go('template')
            })
    }

    createNewTemplate (stateUrl) {
        this._Template.save([], template => {
            this.collection.push(template)
            this.$state.go('template.update', {
                id: template.id,
                create: true,
            })
        })
    }

    duplicate (template) {
        this.$http.post('templateblocks/duplicate/', template)
            .then((data) => {
                let template = data.data
                this.fetch(this.pagination.current)
                this.$state.go('template.update', {
                    id: template.id,
                    create: true,
                })
            })
    }

    checkActive (template) {
        return ('' + template.id) === ('' + this.$state.params.id)
    }
}

TemplateOverviewCtrl.$inject = ['$http', '$timeout', '$state', '$mdDialog', '$mdToast', 'Template']

module.exports = TemplateOverviewCtrl
